import { ModeToggle } from "./mode-toggle";
import { Button } from "./ui/button";
import { Home, ChartNoAxesColumn, ChevronLeft, ChevronRight, ContactRound, Users, User, ChartNetwork, Files, ClipboardList, Package } from "lucide-react";
import { Link } from "@tanstack/react-router";
import { useAuth } from "@/context/AuthContext";
import Notifications from "@/dashboard/notifications";
import { getUserAvatarUrl } from "@/lib/storage/getAvatar";
import { memo, useMemo } from "react";
import { OfflineIndicator } from "./offline/OfflineIndicator";

const tagLinkstyle = "flex items-center font-outfit gap-3 py-4 px-3 text-base font-medium text-muted-foreground hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md";
const activeLinkStyle = "bg-gray-200 dark:bg-gray-700 text-blue-600 dark:text-blue-400";

const Navbar = memo(({ collapsed, setCollapsed }: { collapsed: boolean, setCollapsed: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const { user, userRoles } = useAuth();
  const avatarSrc = useMemo(() => user ? getUserAvatarUrl(user) : "/images/perfil.png", [user]);
  return (
    <>
      <div className="absolute top-5 right-8 hidden lg:flex gap-2">
        <OfflineIndicator />
        <Notifications />
        <ModeToggle />
      </div>
      <aside className={`hidden fixed h-screen shadow-lg lg:flex top-0 flex-col justify-between bg-linear-to-br from-white to-gray-50 dark:from-zinc-800 dark:to-zinc-900 rounded-4xl transition-width duration-300 ${collapsed ? "w-28" : "w-70"}`}>
        <div>
          <div className="flex  items-center justify-between min-h-26 px-4 py-2 mb-6 rounded-t-3xl relative">
            <div className="flex items-center gap-2">
              {collapsed ? (
                <>
                  <img src="/images/isotipo-dark.png" className=" hidden dark:block" />
                  <img src="/images/isotipo-light.png" className="block dark:hidden" />
                </>
              ) : (
                <>
                  {/* Logo para modo claro */}
                  <img
                    src="/images/Logo-light.png"
                    alt="Logo Light"
                    className="block dark:hidden"
                  />
                  { /* use el block dark:hidden para ocultarlo en modo obscuro*/}

                  {/* Logo para modo oscuro */}
                  <img
                    src="/images/Logo-dark.png"
                    alt="Logo Dark"
                    className="hidden dark:block"
                  />
                </>
              )}
            </div>
            <div className={`transition-all duration-300 ${collapsed ? "absolute -right-2.25 top-1/2 -translate-y-1/2 z-40" : ""}`}>
              <Button onClick={() => setCollapsed(!collapsed)} variant="secondary" className="border-gray-200 dark:border-gray-600 border w-8 h-8 cursor-pointer" >
                {collapsed ? <ChevronRight /> : <ChevronLeft />}
              </Button>
            </div>
          </div>

          <div className="px-6">
            <div className="flex items-center gap-3 mb-6 ">
              <img
                src={avatarSrc}
                alt="User"
                className="w-13 h-13 rounded-full object-cover"
              />
              <div>
                {!collapsed && (
                  <>
                    <p className="text-1xl font-lg font-outfit"> {user?.name} </p>
                    <p className="text-xs text-muted-foreground font-nunito"> {user?.labels?.join(" ")}</p>
                  </>
                )}
              </div>
            </div>

            <nav className="flex flex-col gap-2  text-sm font-medium text-muted-foreground">
              <Link to="/dashboard" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><Home className="w-6 h-6" /> {!collapsed && "Dashboard"}</Link>
              <Link to="/requests" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><Files className="w-6 h-6" /> {!collapsed && "Solicitudes"}</Link>
              <Link to="/instruments/listInstruments" hidden={!(userRoles?.isAdmin || userRoles?.isServicioTecnico)} className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><Package className="w-6 h-6" /> {!collapsed && "Instrumentos"}</Link>

              {/* <Link to="/visitLog/$id" params={{ id: user?.$id || '' }} hidden={!(userRoles?.isAsesorComercial || userRoles?.isServicioTecnico)} className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><ClipboardList className="w-6 h-6" /> {!collapsed && "Bitácoras de visita"}</Link> */}
              {(userRoles?.isAsesorComercial || userRoles?.isServicioTecnico) && (
                <Link
                  to="/visitLog/$id"
                  params={{ id: user?.$id || '' }}
                  className={tagLinkstyle}
                  activeProps={{ className: activeLinkStyle }}
                >
                  <ClipboardList className="w-6 h-6" />
                  {!collapsed && "Bitácoras de visita"}
                </Link>
              )}

              <Link to="/activity" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><ChartNoAxesColumn className="w-6 h-6" /> {!collapsed && "Actividad"}</Link>
              <Link to="/workLog" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><ChartNetwork className="w-6 h-6" /> {!collapsed && "Registro de Jornada"}
              </Link>


              <Link to="/assistance" hidden={!(userRoles?.isAdmin || userRoles?.isRRHH)} className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><ContactRound className="w-6 h-6" /> {!collapsed && "Asistencia"}</Link>
              <Link to="/directory" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><Users className="w-6 h-6" /> {!collapsed && "Directorio"}</Link>
              <Link to="/myProfile" className={tagLinkstyle} activeProps={{ className: activeLinkStyle }}><User className="w-6 h-6" /> {!collapsed && "Mi perfil"}</Link>
            </nav>
          </div>
        </div>


        {/* Footer*/}
        <div className="text-center text-xs min-h-10 rounded-b-3xl flex items-center justify-center">
          <div className="text-gray-500 font-nunito">
            Wolf Instruments © 2026
          </div>
        </div>
      </aside>
    </>
  );
});

Navbar.displayName = 'Navbar';

export default Navbar;